import { render, staticRenderFns } from "./MySubtasksTable.vue?vue&type=template&id=2d06cbdd"
import script from "./MySubtasksTable.vue?vue&type=script&lang=js"
export * from "./MySubtasksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports